import { Component, computed, inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { NotificationService } from '../../../features/notifications/services/notification.service';
import { SidebarService } from '../../services/sidebar.service';
import { SidebarPanelType } from '../../models/sidebar-panel';
import { NotificationItem } from '../../../features/notifications/models/notification';
import { NotificationTypes } from '../../constants/domain.constants';

@Component({
  selector: 'app-notification-detail-panel',
  imports: [DatePipe],
  templateUrl: './notification-detail-panel.component.html',
  styleUrl: './notification-detail-panel.component.scss'
})
export class NotificationDetailPanelComponent {
  private readonly notificationService = inject(NotificationService);
  private readonly sidebarService = inject(SidebarService);

  readonly notification = computed<NotificationItem | null>(() => {
    const panel = this.sidebarService.currentPanel();
    if (panel?.type === SidebarPanelType.NotificationDetail) {
      return panel.data;
    }
    return null;
  });

  readonly typeLabel = computed(() => {
    const n = this.notification();
    if (!n) return '';
    return n.notificationType === NotificationTypes.alert ? 'Alert' : 'Message';
  });

  readonly isAlert = computed(() =>
    this.notification()?.notificationType === NotificationTypes.alert
  );

  readonly NotificationTypes = NotificationTypes;

  dismiss(): void {
    const n = this.notification();
    if (n) {
      this.notificationService.markAsRead(n.notificationId);
    }
    this.sidebarService.back();
  }
}
